export { default } from './ForemanForm';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/common/forms/ForemanForm/index.js